(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4395],{

/***/ 82991:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/greenflame",
      function () {
        return __webpack_require__(42595);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_greenflame; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
;// CONCATENATED MODULE: ./src/assets/images/greenflame.jpg
/* harmony default export */ var greenflame = ({"src":"/_next/static/media/greenflame.f016e273.jpg","height":400,"width":1263,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAADAQEBAQAAAAAAAAAAAAABAgMAIQQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAXEQADAQAAAAAAAAAAAAAAAAAAATEC/9oADAMBAAIRAxEAPwCZ+R6LPKcGq5kqFQhbgHeZmYOlMQ//2Q=="});
// EXTERNAL MODULE: ./src/styles/kishalaya.module.scss
var kishalaya_module = __webpack_require__(77645);
var kishalaya_module_default = /*#__PURE__*/__webpack_require__.n(kishalaya_module);
;// CONCATENATED MODULE: ./src/pages/greenflame.tsx



swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
]);




var Greenflame = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (kishalaya_module_default()).csr_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: greenflame,
                    alt: "",
                    width: 1920,
                    height: 608
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (kishalaya_module_default()).table,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "table-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    className: "mt-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 2,
                                                    className: (kishalaya_module_default()).tab_h,
                                                    children: "Project-Green Flame"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 2,
                                                    children: "SENCO GOLD AND DIAMONDS CSR INITIATIVES FOR CREATING LESS POLUTING RURAL KITCHEN"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Executed By"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "PC SEN CHARITABLE TRUST"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Project"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "IMPROVED DOMESTIC CHULA(IDC)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Project Insight"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "The concept of Improved Domestic or Community Chula has been designed by one of our beneficiary NGO, Alinan Ramakrishna Viveka Yuva Sangha, which has overall thermal efficiency of 23.08% and overall power rating of 1.33KW, and has been certified by School of Energy Studies, Jadavpur University. Since 2001, more than 30000 IDC and 200 ICC has been installed in different rural homes, thereby helping Rural Women to have less polluting kitchen."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Installation Target"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "1000 Homes"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Duration"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "(2023-24, 2024-25, 2025-26)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Project Implementation Plan"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                        children: [
                                                            "We started with installing 35 Chullas at homes of the 35 children who are studying at the creche cum pre-primary education centre. More interest were created among the villagers and the other families also requested us to install Chullas at their homes. We increased it to 100 units. Further 100 homes have been increased at Mayachar and 150 units to be installed at ",
                                                            "'",
                                                            "Chandakhali",
                                                            "'",
                                                            " of Kakharada Gram Panchyat and Banomara in Dalhara G.P under Sahid Matangini Block of Purba Medinipur, inhabited by more than 200 underprivileged families who would be benefitted by our IDC."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "table-responsive",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    className: "mt-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 5,
                                                    className: (kishalaya_module_default()).tab_h,
                                                    children: "Implementation Schedule"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Sl No"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Year"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Location"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Total No of Units to be installed"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                        children: "Type of Chulla"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "2023-24"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Mayachar(Mahishadal Block,Purba Medinipur)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "200"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "IDC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                        children: [
                                                            "'",
                                                            "Chandakhali",
                                                            "'",
                                                            " of Kakharada Gram Panchyat and Banomara in Dalhara G.P under Sahid Matangini Block of Purba Medinipur"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "150"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "IDC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Anandaangar Development Society(Purulia)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "ICC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Mayachar(Mahishadal Block,Purba Medinipur)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "ICC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "5"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Vivekananda School & Skill Development Centre, Bamon Mollor Chowk, South 24 Parganas"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "ICC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        colSpan: 3,
                                                        className: "text-end",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Total"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "354"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "0"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var pages_greenflame = (Greenflame);


/***/ }),

/***/ 77645:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab_h":"kishalaya_tab_h__Q0wbr","table":"kishalaya_table__Xvlyg","w_50":"kishalaya_w_50__9z9Xj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(82991); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);